import Image from "next/image";
import Link from "next/link";
import { FiArrowRight } from "react-icons/fi";

const CommonCard = ({ cardData }) => {
    return (
        <div className="container">
            <div className="grid md:grid-cols-2 grid-cols-1 md:gap-12 gap-7">
                {cardData.map((i, index) => {
                    const images = i?.attributes?.image?.data?.map(
                        (img) => img?.attributes?.url
                    );
                    const imgLength = i?.attributes?.image?.data?.length;

                    return (
                      <Link key={index} href={i?.attributes?.link} target="_blank">
                        <div
                          className={`relative flex flex-col ${
                            imgLength > 1 ? "items-center" : "items-end"
                          } bg-[#F8F3FF] rounded-xl w-full cursor-pointer h-[500px] group overflow-hidden`}
                        >
                          <div className="px-10 py-8 flex lg:flex-row flex-col items-baseline lg:gap-10 gap-5">
                            {i?.attributes?.logo?.data?.[0]?.attributes?.url && (
                              <Image
                                src={`${process.env.NEXT_PUBLIC_STRAPI_URL}${i?.attributes?.logo?.data?.[0]?.attributes?.url}`}
                                alt={"Logo"}
                                width={152}
                                height={30}
                                priority={true}
                                style={{
                                  width: "130px",
                                  height: "50px",
                                  objectFit: "contain",
                                }}
                              />
                            )}
                            <div className="flex flex-col justify-center px-5 m-auto">
                              <span className="font-manrope font-bold text-2xl leading-8 text-black">
                                {i?.attributes?.title}
                              </span>
                              <span className="my-1.5 font-medium text-xs leading-3 text-[#410EAD]">
                                {i?.attributes?.category}
                              </span>
                              <p className="font-normal text-sm leading-4 text-[#636363] line-clamp-2">
                                {i?.attributes?.description}
                              </p>
                            </div>
                          </div>

                          <div
                            className={`${
                              imgLength > 1 ? "grid grid-cols-4 gap-4" : "flex justify-center items-center"
                            } xl:p-0 px-2 justify-items-center place-items-center mt-4 xl:w-[600px] lg:w-[500px] md:w-full h-[330px] object-cover`}
                          >
                            {imgLength > 1
                              ? images.map((subItem, imgIndex) => (
                                  <Image
                                    key={imgIndex}
                                    src={`${process.env.NEXT_PUBLIC_STRAPI_URL}${subItem}`}
                                    alt={"Image"}
                                    priority={true}
                                    width={160}
                                    height={160}
                                    className="transition-transform duration-300 ease-in-out transform group-hover:scale-110"
                                    style={{
                                      objectFit: "contain",
                                    }}
                                  />
                                ))
                              : images?.[0] && (
                                  <Image
                                    src={`${process.env.NEXT_PUBLIC_STRAPI_URL}${images[0]}`}
                                    alt={"Image"}
                                    priority={true}
                                    width={580}
                                    height={250}
                                    className="transition-transform duration-300 ease-in-out transform group-hover:scale-110"
                                    style={{
                                      objectFit: "fill",
                                      width: "100%",
                                      height: "100%",
                                    }}
                                  />
                                )}
                          </div>

                          {/* Arrow icon with glass effect */}
                          <div className="absolute -bottom-12 -right-12 transition-all duration-300">
                            <div className="flex items-center justify-center w-36 h-36 bg-white bg-opacity-20 backdrop-blur-md rounded-full shadow-lg">
                              <div className="flex items-center justify-center rounded-full shadow-sm w-10 h-10 group-hover:bg-[#410EAD] group-hover:bg-opacity-50 group-hover:backdrop-blur-lg">
                                <FiArrowRight className="text-black text-3xl font-bold" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    );
                })}
            </div>
        </div>
    );
};

export default CommonCard;
